import React from 'react';
import '../Colors.css';

const CarBoxed = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 283.465 283.632" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='HslBlue' d="M0.015,35.174c0-19.132,15.943-35.075,35.075-35.075h212.576c19.841,0,35.784,15.943,35.784,35.075V247.75
        c0,19.84-15.943,35.784-35.784,35.784H35.09c-19.132,0-35.075-15.943-35.075-35.784V35.174z"/>
      <path className='White' d="M233.202,121.064l-11.174,2.873c8.301,6.066,11.494,17.56,11.494,25.541v29.372
        c0,7.663-5.746,14.367-15.006,15.963v16.921c0,2.554-2.234,3.831-4.789,3.831h-16.921c-2.235,0-4.47-1.277-4.47-3.831v-14.048
        c-13.409,0.639-32.246,1.916-50.763,1.916c-18.836,0-37.034-1.277-50.763-1.916v14.048c0,2.554-2.235,3.831-4.47,3.831H69.418
        c-2.554,0-4.789-1.277-4.789-3.831v-16.921c-8.939-1.596-14.686-8.301-14.686-15.963v-29.372c0-7.982,3.511-19.475,11.812-25.541
        l-11.812-2.873c-4.789-1.277-7.982-5.108-7.343-9.897c0.319-4.789,5.108-8.301,10.535-7.982l16.921,3.193L81.55,85.945
        c4.789-8.94,8.621-13.09,20.114-15.006c12.451-1.596,21.71-2.874,39.908-2.874c17.879,0,28.095,1.277,40.547,2.874
        c11.493,1.915,15.325,6.066,20.114,15.006l11.493,20.433l16.602-3.193c5.108-0.319,10.217,3.193,10.535,7.982
        C241.503,115.955,238.31,119.787,233.202,121.064z M101.345,149.479l-34.8-3.512v8.94c0,4.47,4.151,7.343,8.62,7.343h17.88
        c4.469,0,8.3-2.874,8.3-7.343V149.479z M77.082,120.106c19.156,2.554,43.42,3.831,65.768,3.831
        c21.071,0,42.781-0.638,63.853-3.831l-14.686-30.011c-2.554-5.427-5.427-7.662-11.174-8.939
        c-11.174-2.235-21.71-2.874-39.27-2.874s-27.456,0.639-38.631,2.874c-5.746,1.277-8.621,3.512-11.174,8.939L77.082,120.106z
        M217.558,145.966l-34.161,3.512v5.427c0,4.47,3.831,7.343,8.301,7.343h17.239c4.47,0,8.621-2.874,8.621-7.343V145.966z"/>
    </svg>
  );
};

export default CarBoxed;